module.exports = __webpack_public_path__ + "c04fde8146639f7ac7bf5a631fd0b22c.png";